import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AppComponent } from '../app.component';
import { ConfigurationService } from '../services/configuration.service';
import { TestLoginService } from '../services/test-login.service';
import { TestUserCatalogService } from '../services/test-user-catalog.service';
import { TestLoginDialogComponent } from '../test-login-dialog/test-login-dialog.component';

@Component({
  selector: 'app-noaccess',
  templateUrl: './noaccess.component.html',
  styleUrls: ['./noaccess.component.scss'],
  standalone: false,
})
export class NoAccessComponent implements OnInit {
  public contactMessage: SafeHtml;
  public environment = environment;

  constructor(
    configService: ConfigurationService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private testUserCatalog: TestUserCatalogService,
    private testLoginService: TestLoginService,
    private router: Router,
    private appComponent: AppComponent,
  ) {
    const contactMessage = configService.getConfig().noAccessContactMessage;
    this.contactMessage = this.sanitizer.bypassSecurityTrustHtml(contactMessage); // Prevents XSS
  }

  ngOnInit(): void {}

  showTestLoginDialog(): void {
    const dialogRef = this.dialog.open(TestLoginDialogComponent, {
      width: '400px',
      disableClose: true,
      data: {
        testUsers: this.testUserCatalog.getTestUsers(),
        currentUser: this.testUserCatalog.getCurrentUser(),
      },
    });

    dialogRef.afterClosed().subscribe(async (result: any) => {
      if (result && result.success && result.user) {
        try {
          // Login with test token
          await this.testLoginService.loginWithTestToken(result.user);

          // Set the selected user in the catalog
          this.testUserCatalog.setCurrentUser(result.user);

          // Use AppComponent's method to set the user in the account service
          this.appComponent.setTestUserInAccountService(result.user.id);

          // Update AppComponent's display state
          this.appComponent.loginDisplay = true;
          this.appComponent.displayName = result.user.name;

          // Navigate to home page
          this.router.navigate(['/']);
        } catch (error) {
          console.error('[NoAccess] Error logging in test user:', error);
        }
      }
    });
  }
}
